import { useState } from "react";
import { Card, Title, Button, Divider, TextInput } from "@tremor/react";
import { useNavigate } from "react-router-dom";
import Alert from "../../components/alert";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import * as userAPI from "../../services/user";
import ThemeToggle from "../../components/ThemeToggle";

export default function RegisterPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await userAPI.register(username, password, name);
      setLoading(false);
      navigate("/login?regok=true");
    } catch (err) {
      setLoading(false);
      setError(err.error || "Failed to register");
      setTimeout(() => {
        setError(null);
      }, 3000);
    }
  };

  return (
    <main className="p-4 md:p-10 mx-auto max-w-7xl">
      <ThemeToggle compact className="fixed right-4 top-4" />
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <a href="/" className="flex items-center mb-6 text-2xl font-semibold">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
            <rect x="0" y="0" width="40" height="40" rx="9" ry="9" fill="#2563eb"/>
            <text x="20" y="28" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="300" fontSize="22" fill="#ffffff">Z</text>
          </svg>
          Zafron
        </a>
        <Card className="max-w-xs">
          <Title>Sign Up</Title>
          <Divider />
          {error && (
            <Alert
              title="Register Error"
              message={"Email or password is invalid."}
            >
              {error}
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2"
                htmlFor="name"
              >
                Name:
              </label>
              <TextInput
                id="name"
                type="text"
                placeholder="Azucar"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2"
                htmlFor="email"
              >
                E-mail Address:
              </label>
              <TextInput
                id="email"
                type="email"
                placeholder="E-mail adress"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2"
                htmlFor="password"
              >
                Password:
              </label>
              <TextInput
                id="password"
                type="password"
                placeholder=""
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2"
                htmlFor="confirm-password"
              >
                Confirm Password:
              </label>
              <TextInput id="confirm-password" type="password" placeholder="" />
            </div>
            <div className="mb-4">
              <Button
                disabled={loading}
                variant="primary"
                size="xs"
                className="w-full"
                loading={loading}
              >
                Register
              </Button>
            </div>
          </form>
          <Divider></Divider>
          <div className="mb-4">
            <Button
              icon={ArrowLeftIcon}
              iconPosition="left"
              variant="light"
              size="xs"
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
          </div>
        </Card>
      </div>
    </main>
  );
}
